var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcbBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 136,
    viewBox: "0 0 214 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3246_189)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 214,
    height: 136,
    rx: 5,
    fill: "url(#paint0_linear_3246_189)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.875 1.71037L284.514 33.2563C292.571 40.8121 292.978 53.4689 285.422 61.526L160.242 195.013C118.852 141.773 114.497 72.9585 153.252 31.6315C177.508 5.76596 213.592 -3.93806 250.875 1.71037Z",
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.557 39.4642L304.871 75.4087C310.882 84.6757 308.242 97.0608 298.975 103.072L145.443 202.655C119.819 143.811 133.442 78.0464 180.975 47.2159C210.725 27.9198 247.553 26.3323 281.557 39.4642Z",
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0725 115.552C17.0725 115.102 17.1575 114.68 17.3275 114.285C17.5025 113.89 17.7375 113.545 18.0325 113.25C18.3275 112.95 18.6725 112.715 19.0675 112.545C19.4625 112.375 19.885 112.29 20.335 112.29C20.785 112.29 21.21 112.375 21.61 112.545C22.01 112.715 22.3575 112.95 22.6525 113.25C22.9475 113.545 23.18 113.89 23.35 114.285C23.525 114.68 23.6125 115.102 23.6125 115.552C23.6125 115.997 23.525 116.417 23.35 116.812C23.18 117.202 22.9475 117.545 22.6525 117.84C22.3575 118.135 22.01 118.367 21.61 118.537C21.21 118.707 20.785 118.792 20.335 118.792C19.885 118.792 19.4625 118.707 19.0675 118.537C18.6725 118.367 18.3275 118.135 18.0325 117.84C17.7375 117.545 17.5025 117.202 17.3275 116.812C17.1575 116.417 17.0725 115.997 17.0725 115.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7737 115.552C25.7737 115.102 25.8587 114.68 26.0287 114.285C26.2037 113.89 26.4387 113.545 26.7337 113.25C27.0287 112.95 27.3737 112.715 27.7687 112.545C28.1637 112.375 28.5862 112.29 29.0362 112.29C29.4862 112.29 29.9112 112.375 30.3112 112.545C30.7112 112.715 31.0587 112.95 31.3537 113.25C31.6487 113.545 31.8812 113.89 32.0512 114.285C32.2262 114.68 32.3137 115.102 32.3137 115.552C32.3137 115.997 32.2262 116.417 32.0512 116.812C31.8812 117.202 31.6487 117.545 31.3537 117.84C31.0587 118.135 30.7112 118.367 30.3112 118.537C29.9112 118.707 29.4862 118.792 29.0362 118.792C28.5862 118.792 28.1637 118.707 27.7687 118.537C27.3737 118.367 27.0287 118.135 26.7337 117.84C26.4387 117.545 26.2037 117.202 26.0287 116.812C25.8587 116.417 25.7737 115.997 25.7737 115.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4749 115.552C34.4749 115.102 34.5599 114.68 34.7299 114.285C34.9049 113.89 35.1399 113.545 35.4349 113.25C35.7299 112.95 36.0749 112.715 36.4699 112.545C36.8649 112.375 37.2874 112.29 37.7374 112.29C38.1874 112.29 38.6124 112.375 39.0124 112.545C39.4124 112.715 39.7599 112.95 40.0549 113.25C40.3499 113.545 40.5824 113.89 40.7524 114.285C40.9274 114.68 41.0149 115.102 41.0149 115.552C41.0149 115.997 40.9274 116.417 40.7524 116.812C40.5824 117.202 40.3499 117.545 40.0549 117.84C39.7599 118.135 39.4124 118.367 39.0124 118.537C38.6124 118.707 38.1874 118.792 37.7374 118.792C37.2874 118.792 36.8649 118.707 36.4699 118.537C36.0749 118.367 35.7299 118.135 35.4349 117.84C35.1399 117.545 34.9049 117.202 34.7299 116.812C34.5599 116.417 34.4749 115.997 34.4749 115.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.176 115.552C43.176 115.102 43.261 114.68 43.431 114.285C43.606 113.89 43.841 113.545 44.136 113.25C44.431 112.95 44.776 112.715 45.171 112.545C45.566 112.375 45.9885 112.29 46.4385 112.29C46.8885 112.29 47.3135 112.375 47.7135 112.545C48.1135 112.715 48.461 112.95 48.756 113.25C49.051 113.545 49.2835 113.89 49.4535 114.285C49.6285 114.68 49.716 115.102 49.716 115.552C49.716 115.997 49.6285 116.417 49.4535 116.812C49.2835 117.202 49.051 117.545 48.756 117.84C48.461 118.135 48.1135 118.367 47.7135 118.537C47.3135 118.707 46.8885 118.792 46.4385 118.792C45.9885 118.792 45.566 118.707 45.171 118.537C44.776 118.367 44.431 118.135 44.136 117.84C43.841 117.545 43.606 117.202 43.431 116.812C43.261 116.417 43.176 115.997 43.176 115.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4026 114.42L53.9451 109.155H55.9551C56.0951 109.155 56.1951 109.175 56.2551 109.215C56.3201 109.25 56.3776 109.31 56.4276 109.395L58.8951 113.377C58.9201 113.312 58.9476 113.25 58.9776 113.19C59.0076 113.125 59.0426 113.06 59.0826 112.995L61.3401 109.432C61.4501 109.247 61.5926 109.155 61.7676 109.155H63.7026L60.2076 114.337L63.8001 120H61.7826C61.6476 120 61.5376 119.965 61.4526 119.895C61.3726 119.825 61.3051 119.745 61.2501 119.655L58.7376 115.5C58.7176 115.56 58.6951 115.617 58.6701 115.672C58.6451 115.722 58.6201 115.77 58.5951 115.815L56.1876 119.655C56.1326 119.74 56.0651 119.82 55.9851 119.895C55.9051 119.965 55.8051 120 55.6851 120H53.7951L57.4026 114.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5833 114.42L64.1258 109.155H66.1358C66.2758 109.155 66.3758 109.175 66.4358 109.215C66.5008 109.25 66.5583 109.31 66.6083 109.395L69.0758 113.377C69.1008 113.312 69.1283 113.25 69.1583 113.19C69.1883 113.125 69.2233 113.06 69.2633 112.995L71.5208 109.432C71.6308 109.247 71.7733 109.155 71.9483 109.155H73.8833L70.3883 114.337L73.9808 120H71.9633C71.8283 120 71.7183 119.965 71.6333 119.895C71.5533 119.825 71.4858 119.745 71.4308 119.655L68.9183 115.5C68.8983 115.56 68.8758 115.617 68.8508 115.672C68.8258 115.722 68.8008 115.77 68.7758 115.815L66.3683 119.655C66.3133 119.74 66.2458 119.82 66.1658 119.895C66.0858 119.965 65.9858 120 65.8658 120H63.9758L67.5833 114.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7639 114.42L74.3064 109.155H76.3164C76.4564 109.155 76.5564 109.175 76.6164 109.215C76.6814 109.25 76.7389 109.31 76.7889 109.395L79.2564 113.377C79.2814 113.312 79.3089 113.25 79.3389 113.19C79.3689 113.125 79.4039 113.06 79.4439 112.995L81.7014 109.432C81.8114 109.247 81.9539 109.155 82.1289 109.155H84.0639L80.5689 114.337L84.1614 120H82.1439C82.0089 120 81.8989 119.965 81.8139 119.895C81.7339 119.825 81.6664 119.745 81.6114 119.655L79.0989 115.5C79.0789 115.56 79.0564 115.617 79.0314 115.672C79.0064 115.722 78.9814 115.77 78.9564 115.815L76.5489 119.655C76.4939 119.74 76.4264 119.82 76.3464 119.895C76.2664 119.965 76.1664 120 76.0464 120H74.1564L77.7639 114.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9446 114.42L84.4871 109.155H86.4971C86.6371 109.155 86.7371 109.175 86.7971 109.215C86.8621 109.25 86.9196 109.31 86.9696 109.395L89.4371 113.377C89.4621 113.312 89.4896 113.25 89.5196 113.19C89.5496 113.125 89.5846 113.06 89.6246 112.995L91.8821 109.432C91.9921 109.247 92.1346 109.155 92.3096 109.155H94.2446L90.7496 114.337L94.3421 120H92.3246C92.1896 120 92.0796 119.965 91.9946 119.895C91.9146 119.825 91.8471 119.745 91.7921 119.655L89.2796 115.5C89.2596 115.56 89.2371 115.617 89.2121 115.672C89.1871 115.722 89.1621 115.77 89.1371 115.815L86.7296 119.655C86.6746 119.74 86.6071 119.82 86.5271 119.895C86.4471 119.965 86.3471 120 86.2271 120H84.3371L87.9446 114.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 39.286C56 43.2225 52.7946 46.4279 48.8581 46.4279H10V18.1419C10 14.2054 13.2054 11 17.1419 11H56V39.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3472 32.0318H46.2994C46.3839 32.0318 46.5806 32.0038 46.6651 32.0038C47.2275 31.8913 47.7055 31.3851 47.7055 30.6822C47.7055 30.0074 47.2275 29.5012 46.6651 29.3607C46.5806 29.3325 46.4121 29.3325 46.2996 29.3325H43.3473V32.0318H43.3472Z",
    fill: "url(#paint1_linear_3246_189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9622 13.3899C43.1504 13.3899 40.8447 15.6676 40.8447 18.5074V23.8217H48.071C48.2397 23.8217 48.4365 23.8217 48.577 23.8497C50.2078 23.9341 51.417 24.7776 51.417 26.2395C51.417 27.3924 50.6015 28.3765 49.0832 28.5735V28.6295C50.742 28.742 52.0074 29.6699 52.0074 31.1038C52.0074 32.6504 50.6015 33.6626 48.7457 33.6626H40.8167V44.0661H48.324C51.1357 44.0661 53.4415 41.7886 53.4415 38.9486V13.3899H45.9622Z",
    fill: "url(#paint2_linear_3246_189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3398 26.5772C47.3398 25.9023 46.8619 25.4523 46.2994 25.3679C46.2434 25.3679 46.1027 25.3398 46.0184 25.3398H43.3472V27.8141H46.0184C46.1029 27.8141 46.2714 27.8141 46.2996 27.7861C46.862 27.7017 47.34 27.2519 47.34 26.577L47.3398 26.5772Z",
    fill: "url(#paint3_linear_3246_189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.676 13.3899C14.8643 13.3899 12.5585 15.6676 12.5585 18.5074V31.1322C13.9926 31.835 15.4828 32.2849 16.9731 32.2849C18.7445 32.2849 19.7004 31.2165 19.7004 29.7544V23.7934H24.0868V29.7262C24.0868 32.0318 22.6529 33.9158 17.7885 33.9158C14.8363 33.9158 12.5305 33.2689 12.5305 33.2689V44.0379H20.0379C22.8496 44.0379 25.1554 41.7604 25.1554 38.9204V13.3903H17.6759L17.676 13.3899Z",
    fill: "url(#paint4_linear_3246_189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8192 13.3899C29.0074 13.3899 26.7017 15.6676 26.7017 18.5074V25.1993C27.9952 24.1027 30.2446 23.3997 33.8717 23.5685C35.8118 23.6529 37.8924 24.1871 37.8924 24.1871V26.3522C36.852 25.818 35.6151 25.3398 34.0122 25.2273C31.2567 25.0306 29.5979 26.3802 29.5979 28.742C29.5979 31.1321 31.2567 32.4817 34.0122 32.2567C35.6151 32.1442 36.8522 31.6382 37.8924 31.1321V33.2971C37.8924 33.2971 35.8398 33.8313 33.8717 33.9158C30.2446 34.0843 27.9952 33.3814 26.7018 32.2849V44.0942H34.2092C37.0209 44.0942 39.3265 41.8166 39.3265 38.9767V13.3903H31.8192V13.3899Z",
    fill: "url(#paint5_linear_3246_189)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3246_189",
    x1: 107,
    y1: 0,
    x2: 107,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#354096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A8D57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3246_189",
    x1: -207.374,
    y1: 164.63,
    x2: 1056.18,
    y2: 164.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3246_189",
    x1: 43.127,
    y1: 1545.98,
    x2: 1306.75,
    y2: 1545.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3246_189",
    x1: -207.411,
    y1: 148.703,
    x2: 1056.21,
    y2: 148.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3246_189",
    x1: 14.7525,
    y1: 1545.98,
    x2: 1297.84,
    y2: 1545.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3246_189",
    x1: 19.4298,
    y1: 1545.96,
    x2: 1265.62,
    y2: 1545.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3246_189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 214,
    height: 136,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbBig);
export default __webpack_public_path__ + "static/media/jcbBig.60a3fec92e580ba9e17bbf9f1f702305.svg";
export { ForwardRef as ReactComponent };